const state = {
    leads: [],
    leadId: [],
    contacts: [],
    quotations: [],
    opportunity: [], 
    loading: false
};

export default state;